import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';

import { Context as SocketContext } from '../../../components/Websocket';
import { navigatePush } from '../../../helpers';
import { setQuestion } from '../../../ducks/question';
import AnimatedRoutes from '../components/AnimatedRoutes';
import Question from './Question/Question';
import Waiting from './Question/Waiting';

const propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
    stackPop: PropTypes.func.isRequired,
    stackPush: PropTypes.func.isRequired,
  }).isRequired,
  dispatch: PropTypes.func.isRequired,
  match: PropTypes.shape({
    url: PropTypes.string.isRequired,
  }).isRequired,
};

class Games extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      players: 0,
    };
  }

  componentDidMount() {
    const { dispatch, history } = this.props;
    this.context.join('quiz', (data) => {
      // We either got the question or the results
      dispatch(setQuestion({
        ...data,
        answers: data.correct_answers_and_results || data.answers,
      }));

      if (data.correct_answers_and_results) {
        // Results: wait 5 sec and reset question and go back
        setTimeout(() => {
          dispatch(setQuestion(null));
          history.stackPop();
        }, 5000);
      } else {
        // Go to question route
        navigatePush(history, 'question');
      }
    });
    this.context.join('members:quiz', (data) => {
      this.setState({ players: data });
    });
  }

  componentWillUnmount() {
    this.context.leave('quiz');
    this.context.leave('members:quiz');
  }

  render() {
    const { location, match } = this.props;
    const { players } = this.state;

    return (
      <>
        <Waiting {...this.props} players={players} />
        <AnimatedRoutes location={location}>
          <Route
            path={`${match.url}/question`}
            component={Question}
          />
        </AnimatedRoutes>
      </>
    );
  }
}

Games.propTypes = propTypes;
Games.contextType = SocketContext;

export default connect()(Games);
